import { Fragment, type ReactNode } from 'react';
import { parseMarkdown, type Inline } from '../../shared/markdown';

function renderInline(tokens: Inline[]): ReactNode {
  return tokens.map((token, index) => {
    const key = `${token.type}-${index}`;
    switch (token.type) {
      case 'strong':
        return <strong key={key}>{token.value}</strong>;
      case 'em':
        return <em key={key}>{token.value}</em>;
      case 'code':
        return <code key={key}>{token.value}</code>;
      case 'link':
        return (
          <a key={key} href={token.href} target="_blank" rel="noreferrer noopener">
            {token.value}
          </a>
        );
      default:
        return <Fragment key={key}>{token.value}</Fragment>;
    }
  });
}

/**
 * Rendert Markdown als React-Elemente – kein `dangerouslySetInnerHTML`,
 * damit Ankuendigungstexte kein XSS-Vektor sind (Cookie ist nicht HttpOnly).
 */
export function Markdown({ source }: { source: string }) {
  const blocks = parseMarkdown(source);

  return (
    <>
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;
        if (block.type === 'heading') {
          return block.level === 2 ? (
            <h3 key={key}>{renderInline(block.inline)}</h3>
          ) : (
            <h4 key={key}>{renderInline(block.inline)}</h4>
          );
        }
        if (block.type === 'list') {
          const items = block.items.map((item, i) => <li key={i}>{renderInline(item)}</li>);
          return block.ordered ? <ol key={key}>{items}</ol> : <ul key={key}>{items}</ul>;
        }
        return <p key={key}>{renderInline(block.inline)}</p>;
      })}
    </>
  );
}
